import Axios, { AxiosResponse, AxiosError } from "axios";

export function get(url, headers, params) {
  headers = prepareHeaders(headers);
  return new Promise((resolve, reject) => {
    Axios.get(url, {
      headers,
      params
    })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function post(url, headers, data) {
  headers = prepareHeaders(headers);
  return new Promise((resolve, reject) => {
    Axios.post(url, data, {
      headers
    })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function remove(url, headers, params) {
  headers = prepareHeaders(headers);
  return new Promise((resolve, reject) => {
    Axios.delete(url, {
      headers,
      params
    })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function put(url, headers, data) {
  headers = prepareHeaders(headers);
  return new Promise((resolve, reject) => {
    Axios.put(url, data, {
      headers
    })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function patch(url, headers, data) {
  headers = prepareHeaders(headers);
  return new Promise((resolve, reject) => {
    Axios.patch(url, data, {
      headers
    })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function prepareHeaders(headers) {
  const token = localStorage.getItem("token");
  const lang = localStorage.getItem("lang");
  if (!headers) {
    headers = {};
  }
  if (token) {
    headers.Authorization = `Token ${token}`;
  }
  if (lang) {
    headers["Accept-Language"] = lang;
  }
  // // gecici olarak buraya lang tr ekledik
  // headers["Accept-Language"] = "tr";
  return headers;
}
